import { getAllOrders, OrdersResponse } from 'services/ordersService';
import useUser from 'hooks/useUser';
import { AxiosResponse } from 'axios';
import axios from 'axios';

import { URL_ORDERS } from 'constants/url';
import { PaginationOrders } from 'interfaces/pagination.interface';
import { IOrderDetails } from 'interfaces/order.interface';

export default function useOrders() {
  const { jwt } = useUser();

  const headers = {
    Authorization: `Bearer ${jwt}`
  };

  const getOrders = async (pagination: PaginationOrders): Promise<OrdersResponse> => {
    return await getAllOrders({ jwt, pagination });
  };

  const getOrderByOrderNumber = async (orderNumber: number): Promise<IOrderDetails> => {
    return axios.get(`${URL_ORDERS}/packages/${orderNumber}`, { headers }).then((response: AxiosResponse) => {
      return response.data;
    });
  };

  return {
    getOrders,
    getOrderByOrderNumber
  };
}
